import { ASHLEY_DEBUG_ENABLED } from "../ashley/debug/ashleyDebugConfig";
import { voiceDiag } from "../ashley/debug/ashleyVoiceDiagnostics";

/** TEMP — mic smoke-test UI/logs; follows ASHLEY_DEBUG_ENABLED. */
export const MIC_SMOKE_TEST_ENABLED = ASHLEY_DEBUG_ENABLED;

/**
 * Raw Web Speech API smoke test. No Ashley pipeline — only voiceDiag for debug panel.
 */
export function runMicRecognitionSmokeTest() {
  if (!MIC_SMOKE_TEST_ENABLED) {
    return;
  }

  const log = (message, data) => {
    console.log(message, data ?? "");
    voiceDiag(message, {
      hypothesisId: "H-MIC-TEST",
      location: "micRecognitionSmokeTest",
      data,
    });
  };

  const SpeechRecognition =
    window.SpeechRecognition || window.webkitSpeechRecognition;

  if (!SpeechRecognition) {
    log("TEST: SpeechRecognition unsupported");
    return;
  }

  log("TEST: SpeechRecognition available", {
    api: window.SpeechRecognition ? "SpeechRecognition" : "webkitSpeechRecognition",
  });

  const recognition = new SpeechRecognition();
  recognition.continuous = false;
  recognition.interimResults = false;
  recognition.lang = "en-US";

  recognition.onstart = () => {
    log("TEST: onstart");
  };

  recognition.onerror = (e) => {
    log("TEST: onerror", { error: e.error, message: e.message });
  };

  recognition.onend = () => {
    log("TEST: onend");
  };

  log("TEST: before recognition.start()");

  try {
    recognition.start();
    log("TEST: after recognition.start() (sync return, no throw)");
  } catch (error) {
    log("TEST: recognition.start() THREW", {
      name: error?.name,
      message: error?.message || String(error),
    });
  }
}
